import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import FormInputText from "src/components/Forms/FormInputText";
import FormSelectBox from "../../../../../components/Forms/FormSelectBox";
import { useTranslation } from "react-i18next";
import FormPriceInput from "../../../../../components/Forms/FormPriceInput";
import { FormToggleSwitch } from "../../../../../components/UiComponents/ToggleSwitch";

const EditParkingSlotDialog = ({
  show,
  toggle,
  parking_slot,
  handleSuccess = null,
  parkingSlotCategories = [],
}) => {
  const formRef = useRef();
  const { t } = useTranslation("common");

  function findCategory(category_id = null) {
    if (category_id) {
      return parkingSlotCategories?.entries?.find(
        (c) => c.id === Number(category_id)
      );
    }
  }

  function submit(values, { setSubmitting }) {
    setSubmitting(true);
    if (parking_slot?.name) {
      axios
        .put(`/api/v1/parking_slots/${parking_slot.id}.json`, {
          parking_slot: values,
        })
        .then(function () {
          if (handleSuccess) {
            handleSuccess();
          }
          toggle();
        })
        .catch(function (e) {
          console.error(e);
        });
    } else {
      axios
        .post(`/api/v1/parking_slots.json`, { parking_slot: values })
        .then(function () {
          if (handleSuccess) {
            handleSuccess();
          }
          toggle();
        })
        .catch(function (e) {
          console.error(e);
        });
    }
  }

  if (!show) {
    return <></>;
  }

  return (
    <Modal show={show} onHide={toggle}>
      <Modal.Header>
        <Modal.Title>
          Stellplatz{" "}
          {parking_slot?.duplicate
            ? "duplizieren"
            : parking_slot?.name
            ? `"${parking_slot.name}"`
            : "erstellen"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={
            parking_slot?.id ? parking_slot : { ...parking_slot, active: true }
          }
          enableReinitialize={true}
          onSubmit={submit}
        >
          {() => (
            <Form>
              <FormInputText name="name" label="Name" />
              {/* <FormPriceInput name="day_price" label="Tagespreis" hint={"Wenn leer, dann wird der festgelegte Tagespreis verrechnet"} /> */}
              <FormSelectBox
                name="parking_slot_category_id"
                label="Kategorie"
                hint="Kategorie auswählen"
                options={parkingSlotCategories?.entries}
                option_name="name"
                option_value="id"
              />
              <div className="d-flex flex-nowrap">
                <span className="mr-2">Status: </span>{" "}
                <FormToggleSwitch name="active" />
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          Schließen
        </Button>
        <Button
          variant="primary"
          onClick={() => formRef.current.handleSubmit()}
        >
          {parking_slot?.duplicate
            ? "Duplizieren"
            : !!parking_slot?.name
            ? "Speichern"
            : "Erstellen"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditParkingSlotDialog;
